import { memo } from 'react'
// import { useOnClickOutside } from 'usehooks-ts'
import { NetworkSelectPopup } from './Popup'
import { NetworkSelectCurrent } from './Current'
import { styled } from '@mui/material'
import { MenuItem } from '../Menu/MenuItem'
import { MenuKeys, menuAtom } from '../Menu/atoms'
import { useIsErrorChain } from 'store/app/hooks'

export const NetworkSelectWrap = styled('div')`
  position: relative;
  z-index: 50;
`

export const NetworkSelect = memo(() => {
  const isErrorChain = useIsErrorChain()
  return (
    <MenuItem
      id="zk_network_select"
      menuKey={MenuKeys.Network}
      popup={<NetworkSelectPopup />}
      direction="right"
      style={{
        color: isErrorChain ? 'rgba(246, 70, 93, 1)' : 'inherit',
      }}
      className="nav-item"
    >
      <NetworkSelectCurrent />
    </MenuItem>
  )
})
